import useTranslation from './useTranslation';
export function getStartSide(isLayoutRTL) {
    return isLayoutRTL ? 'right' : 'left';
}
export function getEndSide(isLayoutRTL) {
    return isLayoutRTL ? 'left' : 'right';
}
export function getMirroredSide(value, isLayoutRTL) {
    if (!isLayoutRTL) {
        return value;
    }
    if (value === 'left-center') {
        return 'right-center';
    }
    if (value === 'left') {
        return 'right';
    }
    if (value === 'right-center') {
        return 'left-center';
    }
    if (value === 'right') {
        return 'left';
    }
    return value;
}
export default function useLayoutDirection() {
    const { direction, isLayoutRTL } = useTranslation();
    return {
        direction,
        isLayoutRTL,
        startSide: getStartSide(isLayoutRTL),
        endSide: getEndSide(isLayoutRTL),
    };
}
